export default __webpack_public_path__ + "static/media/selected-pin-location-map.2f135db0.svg";